import React, { useEffect, useState, useContext } from "react";
import { Card } from "../../common_components/Layout";

import UserPoolIcon from '../../../../../../../assets/images/researcher_app/create/create_user_pool.png';
import YourCommunityIcon from '../../../../../../../assets/images/researcher_app/create/create_your_community.png';
import LiveFeedbackIcon from '../../../../../../../assets/images/researcher_app/create/create_live_feedback.png';
import SurveyIcon from '../../../../../../../assets/images/researcher_app/create/create_survey.svg';





function UserPoolButton(props) {

    return (
        <div className="square-button square-button-purple" onClick={props.onClick}>
            <IconHolder>
                <img src={UserPoolIcon} />
            </IconHolder>
            <div className="square-button-text-content">
                <div className="square-button-title-content">
                    <div className="square-button-title">
                        Despark's User Pool
                    </div>
                    <div className="square-button-subtitle">
                        Conduct research with Despark’s users
                    </div>
                </div>
                <div className="square-button-bullet-point-container">
                    <ul className="limited-padding-ul square-button-bullets">
                        <li>We handle the payment, scheduling, recording, surveying, and other logistics</li>
                    </ul>
                </div>
            </div>
        </div>
    )

}

function YourCommunityButton(props) {

    return (
        <div className="square-button square-button-blue" onClick={props.onClick}>
            <IconHolder color="blue-bg">
                <img src={YourCommunityIcon} />
            </IconHolder>
            <div className="square-button-text-content">
                <div className="square-button-title-content">
                    <div className="square-button-title">
                        Your Community
                    </div>
                    <div className="square-button-subtitle">
                        Conduct research with your current users.
                    </div>
                </div>
                <div className="square-button-bullet-point-container">
                    <ul className="limited-padding-ul square-button-bullets">
                        <li>Drop a URL in your social or community channels</li>
                        <li>Filter your users by on-chain activity</li>
                    </ul>
                </div>
            </div>
        </div>
    )

}

function LiveFeedbackButton(props) {

    return (
        <div className="square-button square-button-purple reversed" onClick={props.onClick}>
            <IconHolder>
                <img src={LiveFeedbackIcon} />
            </IconHolder>
            <div className="square-button-text-content">
                <div className="square-button-title-content">
                    <div className="square-button-title">
                        Live Feedback
                    </div>
                    <div className="square-button-subtitle">
                        Flexible 1:1 sessions with users
                    </div>
                </div>
                <div className="square-button-bullet-point-container">
                    <ul className="limited-padding-ul square-button-bullets">
                        <li>We handle the scheduling, recording, and logistics</li>
                        <li>You run the interview session</li>
                    </ul>
                </div>
            </div>
        </div>
    )

}

function SurveyButton(props) {

    return (
        <div className="square-button square-button-purple" onClick={props.onClick}>
            <IconHolder>
                <img src={SurveyIcon} />
            </IconHolder>
            <div className="square-button-text-content">
                <div className="square-button-title-content">
                    <div className="square-button-title">
                        Survey
                    </div>
                    <div className="square-button-subtitle">
                        Robust surveys to quickly reach many users
                    </div>
                </div>
                <div className="square-button-bullet-point-container">
                    <ul className="limited-padding-ul square-button-bullets">
                        <li>Supports complex logic and a large variety of question formats</li>
                    </ul>
                </div>
            </div>
        </div>
    )

}

function IconHolder(props) {
    const holderClass = "square-button-icon-holder " + (props.color ? props.color : "");
    return (
        <div className={holderClass}>
            {props.children}
        </div>
    )
}


export { UserPoolButton, YourCommunityButton, LiveFeedbackButton, SurveyButton, IconHolder };